/* PB Nav Autohide — hide the unified navigation while scrolling, show it again
   at the very top of the page.

   Registration is markup-driven: a section that wants the behaviour renders
   `data-pb-nav-autohide` on its root. The navigation stays in autohide mode for
   as long as at least one such element is in the document, and is handed back
   the moment the last one is gone. That covers the theme editor, where sections
   are added, re-rendered and deleted under a live page: switching the option off
   re-renders the section without the attribute, and deleting the section removes
   it, and either way the next sync puts the navigation back and drops the
   listeners.

   The count is taken from the DOM on every sync rather than kept as a tally of
   its own, which cannot drift out of step with the editor.

   Everything is gated on `pb-nav-autohide` on <html>, a class only added here,
   so nothing reaches a page without one of these sections. */
(function () {
  var MARK = '[data-pb-nav-autohide]';

  if (window.PBNavAutohide) {
    window.PBNavAutohide.sync();
    return;
  }

  var root = document.documentElement;
  var BASE = 'pb-nav-autohide';
  var HIDDEN = 'pb-nav-autohide--hidden';
  var LOCKED = 'pb-nav-autohide--locked';

  /* Below this the page counts as "at the top", which covers iOS rubber-band
     overscroll reporting a couple of stray pixels. */
  var TOP_THRESHOLD = 8;

  var active = false;
  var ticking = false;
  var observer = null;

  function apply() {
    ticking = false;
    if (!active) return;

    var y = window.scrollY || window.pageYOffset || 0;
    root.classList.toggle(HIDDEN, y > TOP_THRESHOLD);
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(apply);
  }

  /* An open menu, search or brand panel hangs off the bar, so keep the bar put
     for as long as one of them is open. */
  function syncLock() {
    if (!active) return;

    var open = !!document.querySelector(
      '.pb-unified-nav__backdrop:not([hidden]), [data-pb-unified-nav][data-open="true"], .pb-unified-nav--menu-open'
    );

    root.classList.toggle(LOCKED, open);
  }

  function activate() {
    if (active) return;
    active = true;

    root.classList.add(BASE);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    if (window.MutationObserver && document.body) {
      observer = new MutationObserver(syncLock);
      observer.observe(document.body, {
        subtree: true,
        attributes: true,
        attributeFilter: ['hidden', 'data-open', 'class'],
      });
    }

    syncLock();
    apply();
  }

  function deactivate() {
    if (!active) return;
    active = false;

    window.removeEventListener('scroll', onScroll);
    window.removeEventListener('resize', onScroll);

    if (observer) {
      observer.disconnect();
      observer = null;
    }

    /* Every class this script owns comes off together, so the navigation is left
       exactly as the theme renders it — not hidden, not locked. */
    root.classList.remove(BASE, HIDDEN, LOCKED);
  }

  /* `removed` is the subtree the theme editor is unloading. It can still be in
     the document when the event fires, so it is discounted explicitly rather
     than trusted to have gone already. */
  function sync(removed) {
    var marks = Array.prototype.slice.call(document.querySelectorAll(MARK));

    if (removed) {
      marks = marks.filter(function (el) {
        return el !== removed && !(removed.contains && removed.contains(el));
      });
    }

    if (marks.length) {
      activate();
    } else {
      deactivate();
    }

    return marks.length;
  }

  window.PBNavAutohide = {
    sync: sync,

    /* For a host that tears the whole thing down rather than a single section. */
    destroy: function () {
      deactivate();
    },
  };

  document.addEventListener('shopify:section:load', function () {
    sync();
  });

  document.addEventListener('shopify:section:unload', function (event) {
    sync(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        sync();
      },
      { once: true }
    );
  } else {
    sync();
  }
})();
